import Marquee from "react-fast-marquee";

export const BrandRibbon = ({ items, className = "" }) => (
  <div className={`relative border-y border-gold/15 bg-navy-950 py-7 md:py-9 ${className}`} data-testid="brand-ribbon">
    <Marquee gradient={false} speed={45} autoFill>
      {items.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-8">
          <span className="font-serif text-4xl md:text-6xl italic text-white/85 whitespace-nowrap">
            {item}
          </span>
          <span className="text-gold text-3xl md:text-5xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
